import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const UPLOAD_DROPZONE_CLASS_NAME = 'UploadDropzone';
export const UPLOAD_DROPZONE_CLASS_SLOTS = ['root', 'splash'] as const;

export type UploadDropzoneClassSlot =
	(typeof UPLOAD_DROPZONE_CLASS_SLOTS)[number];

export interface UploadDropzoneClasses {
	root: string;
	splash: string;
}

export type UploadDropzoneClassKey = keyof UploadDropzoneClasses;

export const getUploadDropzoneUtilityClass = (slot: string) =>
	generateUtilityClass(UPLOAD_DROPZONE_CLASS_NAME, slot);

export const uploadDropzoneClasses: UploadDropzoneClasses =
	generateUtilityClasses(UPLOAD_DROPZONE_CLASS_NAME, ['root', 'splash']);

export default uploadDropzoneClasses;
